import { GET_MILJO_MAKULERINGER_SUCCESS } from "../actions/miljoMakuleringerActions";

const INITIAL_STATE = [];

export default function miljoMakuleringerReducer(
  state = INITIAL_STATE,
  action,
) {
  switch (action.type) {
    case GET_MILJO_MAKULERINGER_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
